export default __webpack_public_path__ + "static/media/business-background-check.a9b96552.webp";